import { useEffect, useRef } from 'react';
import { useCustomer } from '../contexts/CustomerContext';
import useCart from './useCart';

/**
 * Auto-applies a resolved promotional offer coupon to the customer's cart, so the
 * discount is real by the time they reach checkout without them entering a code.
 *
 * Mirrors OfferableCoupon's apply: set couponId, save, refresh context. Uses the
 * MAIN cart (customer.cart), which — unlike apptCart — persists to localStorage,
 * so there's no reload/bounce hazard. Saves at most once per offer id (a ref
 * guards against the effect re-running once couponId round-trips back).
 */
export default function useApplyOfferToCart(offer) {
  const { customer, setCustomer } = useCustomer();
  const { data: cart } = useCart(customer?.cart?.id);
  const appliedRef = useRef(null);

  useEffect(() => {
    if (!offer || !cart) return;
    if (cart.couponId === offer.id) return;
    if (appliedRef.current === offer.id) return;

    appliedRef.current = offer.id;
    cart.couponId = offer.id;
    cart.save().then(() => {
      setCustomer((prev) => ({ ...prev, cart }));
    });
  }, [offer, cart, setCustomer]);
}
